import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress ResizeObserver loop error (benign Chrome quirk - does not affect functionality)
if (typeof window !== 'undefined') {
  const resizeObserverErr = window.onerror;
  window.onerror = function (msg) {
    if (msg === 'ResizeObserver loop completed with undelivered notifications.' || msg === 'ResizeObserver loop limit exceeded') {
      return true;
    }
    if (resizeObserverErr) return resizeObserverErr.apply(this, arguments);
    return false;
  };
}

// Bump APP_VERSION when you deploy so returning users get fresh session/storage
const APP_VERSION = '2';
const VERSION_KEY = 'bsb_app_version';
if (typeof window !== 'undefined') {
  const saved = sessionStorage.getItem(VERSION_KEY);
  if (saved !== APP_VERSION) {
    try {
      sessionStorage.clear();
      localStorage.clear();
      sessionStorage.setItem(VERSION_KEY, APP_VERSION);
    } catch (e) { /* ignore */ }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
